import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=4a1f5091&scoped=true&"
import script from "./Package.vue?vue&type=script&lang=js&"
export * from "./Package.vue?vue&type=script&lang=js&"
import style0 from "./Package.vue?vue&type=style&index=0&id=4a1f5091&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f5091",
  null
  
)

export default component.exports
import {QPage,QForm,QInput,QIcon,QBtn,QCard,QCardSection,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QForm,QInput,QIcon,QBtn,QCard,QCardSection,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QTable})
